module.exports = __webpack_public_path__ + "media/images/features/4/hairmakeartist-395b22173d9004cfbf3804a358e0aa9d.jpg";